function readFile(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = function (evt) {
      resolve(evt.target.result);
    };
    reader.readAsArrayBuffer(file);
  });
}
export const isUtf8 = async function (file) {
  let buffer = await readFile(file);
  if (buffer[0] == 0xff && buffer[1] == 0xfe) {

    console.log('unicode')

  } else if (buffer[0] == 0xfe && buffer[1] == 0xff) {

    console.log('unicode')

  } else if (buffer[0] == 0xef && buffer[1] == 0xbb) {

    console.log('utf8')

  } else {

    console.log('else')

  }

  // let firstCode = new Uint8Array(res)[0];
  // return firstCode >= 33 && firstCode <= 126;
};

export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
    }
  }
  return fmt
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}